import { render, staticRenderFns } from "./ClaimBenefits.vue?vue&type=template&id=721420ff&scoped=true"
import script from "./ClaimBenefits.vue?vue&type=script&lang=js"
export * from "./ClaimBenefits.vue?vue&type=script&lang=js"
import style0 from "./ClaimBenefits.vue?vue&type=style&index=0&id=721420ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721420ff",
  null
  
)

export default component.exports